module.exports = __webpack_public_path__ + "img/logo-white.942c4e3f.png";